import React from "react";
import { StepBoundary } from "../../../types/timeline";

interface StepHandleProps {
  boundary: StepBoundary;
  stepName: string;
  startLabel: string;
  endLabel: string;
  handleForLabel: string;
  onPointerDown: (
    boundary: StepBoundary,
    e: React.PointerEvent<HTMLButtonElement>,
  ) => void;
  onFocus?: (boundary: StepBoundary) => void;
  disabled?: boolean;
}

export const StepHandle = React.memo(function StepHandle({
  boundary,
  stepName,
  startLabel,
  endLabel,
  handleForLabel,
  onPointerDown,
  onFocus,
  disabled = false,
}: StepHandleProps) {
  return (
    <button
      type="button"
      aria-label={`${boundary === "start" ? startLabel : endLabel} ${handleForLabel} ${stepName}`}
      onPointerDown={(e) => onPointerDown(boundary, e)}
      onFocus={() => onFocus?.(boundary)}
      disabled={disabled}
      style={{
        width: 16,
        height: 16,
        borderRadius: 4,
        border: "1px solid rgba(255,255,255,0.85)",
        background: "rgba(15,23,42,0.9)",
        cursor: disabled ? "not-allowed" : "ew-resize",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        pointerEvents: disabled ? "none" : "auto",
      }}
      data-oid="lpv8ygh"
    >
      <span
        style={{
          width: 2,
          height: 8,
          backgroundColor: "rgba(255,255,255,0.8)",
          display: "block",
        }}
        data-oid="eca8-xx"
      />
    </button>
  );
});
